module.exports = __webpack_public_path__ + "img/logo.4e87cbf4.svg";